import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";

import { ReactComponent as Tv } from "../Global/Icons/tv.svg";
import { ReactComponent as Web } from "../Global/Icons/web.svg";

const multiple = nota.global.multiple;

const StyledPlatformSelect = styled.div`
  margin: ${multiple / 2 + "px"} 0;
  .platformSelectWrapper {
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Likely future */
    .optionWrapper {
      background-color: ${nota.color.neutral.NeuFour};
      min-width: ${multiple * 10 + "px"};
      height: ${multiple * 4 + "px"};
      cursor: pointer;
      margin-right: ${multiple / 2 + "px"};
      padding: 6px;
      svg {
        margin-right: ${multiple + "px"};
        path {
          fill: ${nota.color.neutral.NeuOne};
        }
      }
      &:hover {
        opacity: 0.7;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .selectedPlatform {
      background-color: ${nota.color.main.default};
      svg {
        path {
          fill: ${nota.color.neutral.white};
        }
      }
      p {
        color: ${nota.color.neutral.white};
        font-weight: bold;
      }
    }

    .platformDisabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;

class PlatformSelect extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedIds: this.props.selectedIds ? this.props.selectedIds : [],
    };
  }
  componentDidMount() {
    super.componentDidMount();
    /*Prevent different IsAllSelected States from Props to State */
    if (this.props.isAllSelected === true) {
      this.setState({
        selectedIds: [1, 2],
      });
    } else {
      this.validateOptions();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(this.state.selectedIds.sort()) !== JSON.stringify(prevState.selectedIds.sort()) && this.props.onChangeSelection) {
      this.validateOptions();
      this.props.onChangeSelection({ selectedIds: this.state.selectedIds, isAllSelected: this.state.selectedIds.includes(1) && this.state.selectedIds.includes(2) });
    }

    if (prevProps.selectedIds !== this.props.selectedIds || this.props.forceSelection) {
      this.setState({ selectedIds: this.props.selectedIds ? this.props.selectedIds : [] });
    }

    if (prevProps.options !== this.props.options) {
      this.validateOptions();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  validateOptions = () => {
    let options = this.props.options ? this.props.options : [];
    let selected = this.state.selectedIds.filter((id) => {
      return options.includes(id);
    });
    this.setState({ selectedIds: selected });
  };

  onPlatformClick = (v) => {
    if (this.state.selectedIds.includes(v)) {
      this.setState({
        selectedIds: this.state.selectedIds.filter((id) => {
          return id !== v;
        }),
      });
    } else {
      this.setState({ selectedIds: [...this.state.selectedIds, ...[v]] });
    }
  };

  render() {
    return (
      <StyledPlatformSelect>
        <NanoFlex className="platformSelectWrapper" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex
            className={`optionWrapper ${this.state.selectedIds.includes(1) ? "selectedPlatform" : ""} ${!(this.props.options && this.props.options.includes(1)) ? "platformDisabled" : ""}`}
            onClick={() => {
              this.onPlatformClick(1);
            }}>
            <Tv />
            <Type.p>{this.translation.advancedSearch.platforms.TV}</Type.p>
          </NanoFlex>
          <NanoFlex
            className={`optionWrapper ${this.state.selectedIds.includes(2) ? "selectedPlatform" : ""}  ${!(this.props.options && this.props.options.includes(2)) ? "platformDisabled" : ""}`}
            onClick={() => {
              this.onPlatformClick(2);
            }}>
            <Web />
            <Type.p>{this.translation.advancedSearch.platforms.Web}</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledPlatformSelect>
    );
  }
}

// Set default props
PlatformSelect.defaultProps = {};

export default PlatformSelect;

// --- // Documentation // --- //
/*
import PlatformSelect from './../Nano/PlatformSelect.js';

<PlatformSelect />
*/
